import UseOfSoldHeader from "./Header";
import "./index.css";
import { useState } from "react";
import CompDirectUseSoldContent from "./CompDirectUseSold";
import IntermediateUseContents from "./IntermediateUseSold";
import IndirectUseContents from "./CompIndirectUseSold";
import { ShowHide } from "../components/ShowHideCompany";
import FlowNumbersBox from "../components/FlowNumbersBox";
const UseOfSoldComponent = ({ businessId }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="comp-use-sold-container" id="comp-usc-id">
      <UseOfSoldHeader businessId={businessId} show={show} />
      <div style={{ display: "flex", alignItems: "center" }}>
        <ShowHide show={show} setShow={setShow} />
        <div style={{ position: "absolute", bottom: "30px", right: "14%" }}>
          <FlowNumbersBox
            isNormal={true}
            number={"Flow 17"}
            color={"#193666"}
          />
        </div>
      </div>
      {show && <CompDirectUseSoldContent businessId={businessId} />}
      {show && <IndirectUseContents businessId={businessId} />}
      {show && <IntermediateUseContents businessId={businessId} />}
    </div>
  );
};

export default UseOfSoldComponent;
